// src/constants/roleRedirect.js
// Always return a safe path for the given role.
// Keep this dead simple to avoid runtime crashes.

export function handleUserRoleRedirect(userRole) {
  const role = (userRole || '').toLowerCase()

  // Map each role to the route you want them to land on after sign-in
  const map = {
    admin: '/home',
    sales: '/home',
    operations: '/home',
    ops: '/home',
    design: '/home',
    setter: '/home',
    customer: '/portal',
    marketing_reviewer: '/marketing',
  }

  // Fallback: home for any unknown/missing role
  return map[role] || '/home'
}

// Where a signed-in account belongs, from its role list: admin wins, else the first role. The router sends a
// signed-in user here from the sign-in and signed-out pages, and App.vue sends a signed-out tab here when the
// session comes back to it from another tab (docs/bugs/signed_out_page_hosts_live_session_BUG.md).
export function homePathForRoles(roles) {
  const list = roles || []
  return handleUserRoleRedirect(list.includes('admin') ? 'admin' : list[0] || 'sales')
}
